import React from 'react';

const PrivacyPolicy = () => {

  return (
    <>
      <div className="admin-content">
        <h1>Terms of Use</h1>
        <hr className="account-divider" />
        <div className="privacy-policy-container">
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using RCLcheck.com (the "Website"), you agree to comply with and be bound by these Terms of Use. If you do not agree to these terms, you must not use this Website.</p>

          <h2>2. Purpose of the Tool</h2>
          <p>RCLcheck.com provides a tool designed to assist engineers and designers in performing refrigerant safety compliance calculations based on ASHRAE 15 and ASHRAE 15.2 standards. The tool is intended for informational purposes only and should not be solely relied upon for final engineering or design decisions.</p>

          <h2>3. No Warranty or Guarantee</h2>
          <p>RCLcheck.com and its operators make no warranties, express or implied, regarding the accuracy, completeness, or reliability of the calculations provided. The tool is provided "as-is," and the Website disclaims all liability for errors, inaccuracies, or omissions.</p>

          <h2>4. Responsibility for Verification</h2>
          <p>It is the responsibility of the user, including engineers, designers, and other professionals, to independently verify all calculation results generated by the tool. Users must exercise professional judgment and adhere to all applicable regulations and industry standards when applying these calculations to real-world scenarios.</p>

          <h2>5. Limitation of Liability</h2>
          <p>Under no circumstances shall RCLcheck.com, its affiliates, employees, or operators be liable for any direct, indirect, incidental, consequential, or special damages arising from the use of this tool, even if advised of the possibility of such damages. Users assume full responsibility for their reliance on the tool’s outputs.</p>

          <h2>6. Modifications to Terms</h2>
          <p>RCLcheck.com reserves the right to modify these Terms of Use at any time without prior notice. Continued use of the Website after changes are made constitutes acceptance of the modified terms.</p>

          <h2>7. Governing Law</h2>
          <p>These Terms of Use shall be governed by and construed in accordance with the laws of the jurisdiction in which the Website operates.</p>

          <h2>8. Contact Information</h2>
          <p>For any questions regarding these Terms of Use, please contact us at [Insert Contact Email].</p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;

